export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_PDS_BANCA_BM-750773b4a602322ef550c5300d390cf5.pdf";